import styles from "./index.module.scss";

const MessageHouseNotPresent = ({ message }) => {
  return (
    <h4 className={styles.TextMessageHouseNotPresent}>
      {message}
    </h4>
  );
};

export default MessageHouseNotPresent;
